(function () {
  'use strict';

  const LS_KEY = 'cg_wishlist_meta';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(LS_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify(list));
    } catch {}
  }

  function isWished(id) {
    return getWishlist().some(item => String(item.id) === String(id));
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const id = String(btn.dataset.productId);
      btn.classList.toggle('is-active', isWished(id));
    });

    updateCount();
  }

  function updateCount() {
    const count = getWishlist().length;

    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
    });

    document.querySelectorAll('[data-wishlist-badge]').forEach(el => {
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function getProductMeta(btn) {
    return {
      id: btn.dataset.productId,
      title: btn.dataset.productTitle || '',
      url: btn.dataset.productUrl || '',
      image: btn.dataset.productImage || '',
      price: btn.dataset.productPrice || ''
    };
  }

  function initWishlistButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const id = String(btn.dataset.productId);

      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';

      btn.classList.toggle('is-active', isWished(id));

      btn.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        let list = getWishlist();

        if (list.some(item => String(item.id) === id)) {
          list = list.filter(item => String(item.id) !== id);
        } else {
          list.push(getProductMeta(btn));
        }

        saveWishlist(list);
        syncAllButtons();

        // cross-tab sync
        localStorage.setItem('_cg_wish_sync', Date.now());
      });
    });
  }

  window.__wishlistRender = function () {
    const container = document.querySelector('[data-wishlist-page]');
    if (!container) return;

    const items = getWishlist();

    if (!items.length) {
      container.innerHTML = `
        <div class="wl-empty">
          <svg width="56" height="52" viewBox="0 0 20 18" fill="none" aria-hidden="true">
            <path d="M10 16.5C10 16.5 1.5 10.5 1.5 5.25C1.5 3.04 3.29 1.25 5.5 1.25C7.06 1.25 8.42 2.12 9.12 3.4L10 4.93L10.88 3.4C11.58 2.12 12.94 1.25 14.5 1.25C16.71 1.25 18.5 3.04 18.5 5.25C18.5 10.5 10 16.5 10 16.5Z" stroke="#ccc" stroke-width="1.4"/>
          </svg>
          <p class="wl-empty__title">Your wishlist is empty</p>
          <p class="wl-empty__sub">Save items you love and come back to them anytime.</p>
          <a href="/collections/all" class="wl-empty__cta">Browse Products</a>
        </div>
      `;
      return;
    }

    const html = items.map(item => `
      <div class="wl-card" data-wl-id="${item.id}">
        <button class="wl-card__remove" data-wl-remove="${item.id}" aria-label="Remove from wishlist">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
        <a href="${item.url || '#'}" class="wl-card__img-link">
          <div class="wl-card__img-wrap">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
          </div>
        </a>
        <div class="wl-card__body">
          <a href="${item.url || '#'}" class="wl-card__title">${item.title || 'Product'}</a>
          <p class="wl-card__price">${item.price || ''}</p>
          <a href="${item.url || '#'}" class="wl-card__cta">View Product</a>
        </div>
      </div>
    `).join('');

    container.innerHTML = `<div class="wl-grid">${html}</div>`;

    // Remove buttons
    container.querySelectorAll('[data-wl-remove]').forEach(btn => {
      btn.addEventListener('click', () => {
        let list = getWishlist();
        const id = btn.dataset.wlRemove;

        list = list.filter(item => String(item.id) !== id);
        saveWishlist(list);

        syncAllButtons();
        window.__wishlistRender();

        localStorage.setItem('_cg_wish_sync', Date.now());
      });
    });
  };

  function boot() {
    initWishlistButtons();
    syncAllButtons();
    window.__wishlistRender();
  }

  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('pageshow', boot);
  window.addEventListener('storage', e => {
    if (e.key === LS_KEY || e.key === '_cg_wish_sync') {
      syncAllButtons();
      window.__wishlistRender();
    }
  });
  document.addEventListener('shopify:section:load', boot);

})();